import themeStyled from '../../theme'

export const Image = themeStyled.img`
  width: 100%;
`
